import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AnalyticsDashboard\StatisticsExportController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/StatisticsExportController.php
* @route '/api/statistics/statistic-export/{stat}'
*/
const StatisticsExportController = (args: { stat: string | number } | [stat: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StatisticsExportController.url(args, options),
    method: 'post',
})

StatisticsExportController.definition = {
    methods: ["post"],
    url: '/api/statistics/statistic-export/{stat}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\StatisticsExportController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/StatisticsExportController.php
* @route '/api/statistics/statistic-export/{stat}'
*/
StatisticsExportController.url = (args: { stat: string | number } | [stat: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { stat: args }
    }

    if (Array.isArray(args)) {
        args = {
            stat: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        stat: args.stat,
    }

    return StatisticsExportController.definition.url
            .replace('{stat}', parsedArgs.stat.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\StatisticsExportController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/StatisticsExportController.php
* @route '/api/statistics/statistic-export/{stat}'
*/
StatisticsExportController.post = (args: { stat: string | number } | [stat: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StatisticsExportController.url(args, options),
    method: 'post',
})

export default StatisticsExportController